import type { RouteLocationNormalized } from 'vue-router';
import { useAuthApi } from '@/shared/API/Root';
import { useCookiesStore } from '@/shared/stores/cookies.store';
import consola from 'consola';

export async function authGuard(
    to: RouteLocationNormalized,
): Promise<void | { name: string; query: Record<string, string> }> {
    const authApi = useAuthApi();

    try {
        const cookie = await authApi.checkCookie();
        const cookiesStore = useCookiesStore();
        cookiesStore.cookie = cookie.data;
    } catch (error) {
        consola.error(error);
        return {
            name: 'login',
            query: {
                redirect: to.fullPath
            }
        };
    }
}
